const cepMascara = (valor: string) => {

    valor = valor.replace(/\D/g, '')
    valor = valor.replace(/^(\d{5})(\d)/g,"$1 - $2")
    
    return valor

}

export default cepMascara